<template>
  <div>
    <v-radio-group
      v-if="isMrpaGuidEnable"
      v-model="v.mrpa.type.$model"
      row
      :disabled="v.formVisible.$model"
    >
      <v-radio
        label="Файл и подпись доверенности в машиночитаемом виде"
        :value="MrpaType.BY_FILE"
      />
      <v-radio
        label="Реквизиты доверенности в машиночитаемом виде"
        :value="MrpaType.BY_GUID"
      />
    </v-radio-group>

    <p class="d-flex align-start text">
      <v-icon class="mr-2"> {{ mdiAlertCircleOutline }} </v-icon>
      <span>
        Внимание ! Принимается файл и подпись доверенности в машиночитаемом в
        виде только в формате, разработанном ФНС России
      </span>
    </p>

    <p class="d-flex align-start text">
      <v-icon class="mr-2"> {{ mdiAlertCircleOutline }} </v-icon>
      <span>
        Внимание ! Принимается доверенность в машиночитаемом в виде с машиночитаемыми полномочиями
      </span>
    </p>

    <AttachDocumentSingle
      v-if="v.mrpa.type.$model === MrpaType.BY_FILE"
      :load-profile-document-type="DocumentType.MRP"
      :value="{
        file: v.mrpa.file.$model,
        fileSig: v.mrpa.fileSig.$model
      }"
      :error-messages="getValidationErrorText(v.mrpa.file)"
      @change="
        v.mrpa.file.$model = $event.file;
        v.mrpa.fileSig.$model = $event.fileSig;
      "
      @change-from-profile="
        v.mrpa.file.$model = $event.file;
        v.mrpa.fileSig.$model = $event.fileSig;
      "
      :disabled-remove="v.formVisible.$model"
      disabled-sign
      disabled-sig-name-validation
      :accept-file="['.xml']"
      :document-types="documentTypes"
      :withSelect="statementType === StatementType.NOTICE_RECOVERY && isNoticeRecoveryClassifierEnable"
      :has-description="statementType === StatementType.NOTICE_RECOVERY && isNoticeRecoveryClassifierEnable"
			:hint="false"
    />

    <v-row v-else>
      <v-col cols="12">
        <v-text-field
          label="Единый регистрационный номер доверенности"
          outlined
          v-model="v.mrpa.guid.$model"
          :errorMessages="getValidationErrorText(v.mrpa.guid)"
          :disabled="v.formVisible.$model"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="ИНН лица, выдавшего доверенность"
          outlined
          v-model="v.mrpa.issuerInn.$model"
          :errorMessages="getValidationErrorText(v.mrpa.issuerInn)"
          :disabled="v.formVisible.$model"
        />
      </v-col>
    </v-row>

    <div class="text-right mb-5">
      <v-btn
        v-if="v.formVisible.$model"
        depressed
        color="primary"
        class="button-base"
        @click="$emit('parsed-mrpa-change', null)"
      >
        Отменить заполнение сведений по МЧД
      </v-btn>
      <v-btn
        v-else
        depressed
        color="primary"
        class="button-base"
        @click="uploadMrpa"
        :loading="loading"
      >
        Загрузить сведения
      </v-btn>
      <div class="uds-error">
        <div>{{ getValidationErrorText(v.formVisible)[0] }}</div>
      </div>
    </div>

    <base-modal-view v-model="trusteeSelectorDialog" :divider="false">
      <template v-slot:title>Выбор представителя</template>
      <template v-slot:body>
        <v-select
          v-if="mrpaItems"
          v-model="selectedTrustee"
          label="Представитель"
          outlined
          :items="mrpaItems"
          :item-text="trusteeSelectorItemName"
          :item-value="(item) => item"
        >
        </v-select>
      </template>
      <template v-slot:buttons>
        <v-btn
            depressed
            class="button-base-white mr-5"
            @click="trusteeSelectorDialog = false"
        >
          Отмена
        </v-btn>
        <v-btn
            depressed
            color="primary"
            class="button-base"
            @click="selectTrustee"
        >
          Принять
        </v-btn>
      </template>

    </base-modal-view>
  </div>
</template>

<script>
import { isMrpaGuidEnable, isMrpaFileEnable } from '@/app.config';
import { getValidationErrorText } from '@/utils/validate';
import AttachDocumentSingle from '@/components/base/AttachDocument/AttachDocumentSingle';
import {FieldName, MrpaType, StatementType} from '@/constants';
import { mdiAlertCircleOutline } from '@mdi/js';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { MrpaSubjectModule } from '@/store/modules/mrpaSubject';
import { DocumentType } from '@/types/services';
import BaseModalView from "@/components/base/BaseModalView.vue";
import {UploadDocumentTypes} from "@/utils/uploadDocumentTypes";
import { isNoticeRecoveryClassifierEnable } from '@/app.config';

export const mrpaUploaderModel = {
  mrpa: {
    type: MrpaType.BY_FILE,
    guid: '',
    issuerInn: '',
    file: null,
    fileSig: null,
  },
  formVisible: null,
};

export const mrpaUploaderValidation = {
  mrpa: {
    type: {},
    guid: {
      required: requiredIf((vm) => vm.type === MrpaType.BY_GUID),
    },
    issuerInn: {
      required: requiredIf((vm) => vm.type === MrpaType.BY_GUID),
    },
    file: {
      required: requiredIf((vm) => vm.type === MrpaType.BY_FILE),
    },
    fileSig: {},
  },
  formVisible: {
    required,
  },
};

export const prefillMrpDisabled = (subject) => {
  if (subject.identityDocument) {
    subject.identityDocument.mrpDisabled = [];

    if (subject.identityDocument.series) {
      subject.identityDocument.mrpDisabled.push(FieldName.DOCUMENT_SERIES);
    }
  }

  if (subject.trustee) {
    if (subject.trustee.documents.identityDocument) {
      subject.trustee.documents.identityDocument.mrpDisabled = [];

      if (subject.trustee.documents.identityDocument.series) {
        subject.trustee.documents.identityDocument.mrpDisabled.push(
          FieldName.DOCUMENT_SERIES
        );
      }
    }
  }

  if (subject.trusteeOrganization) {
    if (subject.trusteeOrganization.assignee.documents.identityDocument) {
      subject.trusteeOrganization.assignee.documents.identityDocument.mrpDisabled = [];

      if (
        subject.trusteeOrganization.assignee.documents.identityDocument.series
      ) {
        subject.trusteeOrganization.assignee.documents.identityDocument.mrpDisabled.push(
          FieldName.DOCUMENT_SERIES
        );
      }
    }
  }

  if (subject.person) {
    subject.person.mrpDisabled = [];

    if (subject.person.inn) {
      subject.person.mrpDisabled.push(FieldName.INN);
    }

    if (subject.person.snils) {
      subject.person.mrpDisabled.push(FieldName.SNILS);
    }
  }

  if (subject.organization) {
    subject.organization.mrpDisabled = [];

    if (subject.organization.assigneeSnils) {
      subject.organization.mrpDisabled.push('assigneeSnils');
    }
  }

  if (subject.foreignOrganization) {
    subject.foreignOrganization.mrpDisabled = [];

    if (subject.foreignOrganization.inn) {
      subject.foreignOrganization.mrpDisabled.push(FieldName.INN);
    }
  }
};

export const getMrpa = (subject) => {
  if (subject.trustee.documents?.authorityDocument?.file) {
    const { file, fileSig } = subject.trustee.documents.authorityDocument;

    return {
      type: MrpaType.BY_FILE,
      file,
      fileSig,
      guid: '',
      issuerInn: '',
    };
  }

  const { issueNumber, mrpIssuerInn } = subject.trustee.baseAuthority;

  return {
    type: MrpaType.BY_GUID,
    file: null,
    fileSig: null,
    guid: issueNumber,
    issuerInn: mrpIssuerInn,
  };
};

export default {
  name: 'MrpaUploader',
  components: {
    BaseModalView,
    AttachDocumentSingle,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
    isParticipant: {
      type: Boolean,
    },
    statementId: {
      type: String,
    },
    statementType: {
      type: String,
    },
  },
  data: () => ({
    DocumentType,
    MrpaType,
    mdiAlertCircleOutline,
    getValidationErrorText,
    trusteeSelectorDialog: false,
    selectedTrustee: null,
    StatementType,
    isNoticeRecoveryClassifierEnable,
  }),
  computed: {
    loading() {
      return MrpaSubjectModule.loading;
    },

    isMrpaFileEnable() {
      return isMrpaFileEnable(this.statementType);
    },

    isMrpaGuidEnable() {
      return isMrpaGuidEnable(this.statementType);
    },
    mrpaItems() {
      return MrpaSubjectModule.entityMultiple
    },
    documentTypes() {
      const docsCodes = ['12302']
      return UploadDocumentTypes
        .filter((item) => ['12300'].includes(item.groupCode))
        .map((item) => {
          return {
            ...item,
            documents: item.documents.filter((doc => docsCodes.includes(doc.value)))
          }
        })
    }
  },
  methods: {
    selectTrustee() {
      if (this.selectedTrustee) {
        MrpaSubjectModule.setMrpaSubject(this.selectedTrustee)
        this.trusteeSelectorDialog = false
        this.$emit('parsed-mrpa-change', MrpaSubjectModule.entity);
      }
    },
    trusteeSelectorItemName(item) {
      return`${item.trustee?.lastName || ''} ${item.trustee?.firstName || ''} ${item.trustee?.patronymic || ''}`
    },
    async uploadMrpa() {
      this.v.mrpa.$touch();

      if (this.v.mrpa.$invalid) return;

      try {
        if (this.v.mrpa.type.$model === MrpaType.BY_FILE) {
          const checkMrpaFile = this.isParticipant
            ? MrpaSubjectModule.checkMrpaParticipantFile
            : this.statementType === StatementType.ACCEPTANCE_ESCROW
                ? MrpaSubjectModule.checkMrpaSubjectFileMultiple
                : MrpaSubjectModule.checkMrpaSubjectFile

          await checkMrpaFile({
            statementId: this.statementId,
            statementType: this.statementType,
            xml: this.v.mrpa.file.$model.link,
            sig: this.v.mrpa.fileSig.$model.link,
          });
        } else {
          const checkMrpaGuid = this.isParticipant
            ? MrpaSubjectModule.checkMrpaParticipantGuid
            : this.statementType === StatementType.ACCEPTANCE_ESCROW
                ? MrpaSubjectModule.checkMrpaSubjectGuidMultiple
                : MrpaSubjectModule.checkMrpaSubjectGuid

          await checkMrpaGuid({
            statementId: this.statementId,
            statementType: this.statementType,
            guid: this.v.mrpa.guid.$model,
            issuerInn: this.v.mrpa.issuerInn.$model,
          });
        }

        if (MrpaSubjectModule.entityMultiple && MrpaSubjectModule.entityMultiple.length > 1 && this.statementType === StatementType.ACCEPTANCE_ESCROW) {
          this.selectedTrustee = MrpaSubjectModule.entityMultiple[0]
          this.trusteeSelectorDialog = true
        } else {
          this.$emit('parsed-mrpa-change', MrpaSubjectModule.entity);
        }
      } catch (e) {
        await this.$vuetify.goTo('#header-target', { duration: 100 });
      }
    },
  },
};
</script>
